import React, { useState } from 'react'
import { registerModal, useModal } from '@gluedigital/modal'
import { Partition } from 'src/types'

import './PartitionPicker.sass'

interface PartitionPickerProps {
  partitions: Partition[]
  selectedPartitionIds: string[]
  setSelectedPartitionIds: (x: string[]) => void
}

const PartitionPickerModal = ({ partitions, selectedPartitionIds, setSelectedPartitionIds }: PartitionPickerProps) => {
  const modal = useModal()
  const [sp, setSp] = useState(selectedPartitionIds)

  const handleSave = () => {
    setSelectedPartitionIds(sp)
    modal.hide()
  }
  const handleCancel = () => modal.hide()
  const handleAll = () => setSp([])
  const handlePartition = (p: Partition) => () => {
    if (sp.includes(p.id)) {
      // Partition already selected; unselect it
      setSp(sp.filter(s => s !== p.id))
    } else if (partitions.length === 2 && sp.length === 1) {
      // Only two partitions, other one selected; switch
      setSp([p.id])
    } else if (sp.length + 1 === partitions.length) {
      // Selected all partitions individually; set as "ALL"
      setSp([])
    } else {
      // No special cases, jsut select it
      setSp([...sp, p.id])
    }
  }

  return (
    <div className="modal-content partition-picker-modal">
      <h1>
        Seleccione particiones
      </h1>
      <ul>
        <li onClick={handleAll} className={sp.length === 0 ? 'selected' : ''}>
          Todas
        </li>
        {partitions.map(p =>
          <li onClick={handlePartition(p)} className={sp.includes(p.id) ? 'selected' : ''}>
            <span className={`status status-${p.isArmed ? 'armed' : 'disarmed'}`} />
            <span>
              {p.name || ('Partición ' + p.idx)}
            </span>
          </li>
        )}
      </ul>
      <div className="action-buttons">
        <button onClick={handleCancel}>Cancelar</button>
        <button className="filled" onClick={handleSave}>Aceptar</button>
      </div>
    </div>
  )
}

registerModal('partition-picker', PartitionPickerModal)
